import { removeEmpty } from '@src/lib/removeEmpty'
import qs from 'qs'

export function startups3Url(path: string = '/', queryParams = null, hash = null) {
  if (path?.indexOf('http') === 0) {
    return path
  }
  return `${process.env.NEXT_PUBLIC_SCO_URL || 'https://site.startups.com'}${
    !path?.startsWith('/') ? '/' : ''
  }${path}${queryParams ? '?' + qs.stringify(queryParams) : ''}${hash ? `#${hash}` : ''}`
}

export function scoBackendUrl(path: string = '/', queryParams = null, hash = null) {
  if (path?.indexOf('http') === 0) {
    return path
  }
  return `${process.env.NEXT_PUBLIC_SCO_BACKEND_URL || 'https://api.startups.com'}${
    !path?.startsWith('/') ? '/' : ''
  }${path}${queryParams ? '?' + qs.stringify(removeEmpty(queryParams)) : ''}${hash ? `#${hash}` : ''}`
}

export function startupsUrl(path: string = '/', queryParams = null, hash = null) {
  if (path?.indexOf('http') === 0) {
    return path
  }
  return `${process.env.NEXT_PUBLIC_NEXT_URL || 'https://www.startups.com'}${
    !path?.startsWith('/') ? '/' : ''
  }${path}${queryParams ? '?' + qs.stringify(removeEmpty(queryParams)) : ''}${hash ? `#${hash}` : ''}`
}

export function startupsPath(path: string = '/', queryParams = null, hash = null) {
  if (path?.indexOf('http') === 0) {
    return path
  }
  return `${!path?.startsWith('/') ? '/' : ''}${path}${
    queryParams ? `?${qs.stringify(removeEmpty(queryParams))}` : ''
  }${hash ? `#${hash}` : ''}`
}

export function ensureValidHref(href) {
  if (!href) {
    return '#'
  }

  const lcHref = href.toLowerCase()

  if (lcHref.startsWith('http') || lcHref.startsWith('//')) {
    return href
  } else {
    return `https://${href}`
  }
}
